<template>
  <!-- 新春年货节活动 -->
  <x-page
    :transparent-header="true"
    :enable-header-parallax="true"
    :class="_.page"
    :loading="loading"
  >
    <template v-if="!loading" #header="{ headerParallaxRate, handleBackClick }">
      <div
        :class="_.header"
        :style="{
          backgroundColor:
            headerParallaxRate === 0
              ? 'transparent'
              : `rgba(228, 0, 0, ${headerParallaxRate})`,
        }"
      >
        <!-- 返回 -->
        <x-icon name="back" :class="_.back" @click="handleBackClick" />

        <!-- 标题 -->
        <div :class="_.title">新春盲盒</div>

        <!-- 我的盒柜 -->
        <div
          v-track="{
            name: '盲盒首页-我的盒柜',
            id: '5d773c03-b0ad-4b9e-ac0e-7df393b9611d',
          }"
          :class="_.my"
          @click="handleMyBoxClick"
        >
          <van-badge
            :content="
              unopenData ? (unopenData > 99 ? '99+' : unopenData) : undefined
            "
          >
            <x-icon name="box" :class="_.icon" />
          </van-badge>
          <div :class="_.text">我的盒柜</div>
        </div>
      </div>
    </template>

    <template v-if="!loading">
      <!-- 头图 -->
      <div :class="_.headImage">
        <img :src="require('./images/首页头图.png')" :class="_.image" />
        <!-- <img :src="require('./images/首页头图2.png')" :class="_.image" /> -->
        <div
          v-track="{
            name: '盲盒规则',
            id: 'dd9c9d49-150a-42d9-8911-6fcabc53ee62',
          }"
          :class="_.floatRule"
          @click="handleRuleClick"
        >
          <div>规</div>
          <div>则</div>
        </div>
      </div>

      <!-- 布局辅助器 -->
      <div :class="_.layoutHelper"></div>

      <!-- 弹幕 -->
      <Danmu2025 :class="_.danmu" :data="danmus" />

      <!-- 列表 -->
      <div :class="_.list">
        <div
          v-for="(item, index) in homeData.boxs"
          :key="item.boxId"
          v-track="{
            name: '商品展示',
            id: '974a157b-9863-453c-9c38-cb1eb7523f32',
            resource: {
              id: item.boxId,
              name: item.boxName,
            },
            index: index,
          }"
          :class="[_.item, item.surplusStock === 0 && _.sold]"
          @click="handleItemClick(item)"
        >
          <div :class="_.container">
            <div :class="_.cover">
              <img :src="item.boxPic" :class="_.image" />
            </div>
            <div :class="_.content">
              <div :class="_.title">
                <div :class="[_.name, _._ellipsis2]">
                  {{ item.boxName }}
                </div>
              </div>
              <!-- <div :class="_.count">
                {{ item.openCount ? `已开启${item.openCount}次` : '暂未开启' }}
              </div> -->
              <div :class="_.extra">
                <x-price
                  unit="¥"
                  :value="item.price"
                  :unit-size="16"
                  :value-size="24"
                  color="#F22F49"
                />
                <div :class="_.button">
                  {{ item.surplusStock === 0 ? '已售罄' : '开盲盒' }}
                </div>
              </div>
            </div>
          </div>
          <div :class="_.tag">可试玩</div>
        </div>
      </div>

      <!-- 规则 -->
      <div :class="_.rule">
        <div :class="_.container">
          <div :class="_.title">盲盒规则</div>
          <div :class="_.content">{{ homeData.rule }}</div>
          <div :class="_.tips">
            活动最终解释权归贵州多彩宝互联网服务有限公司所有。
          </div>
        </div>
      </div>

      <!-- 回首页 -->
      <x-float-home />
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { addDispose, mapQuery, prepareData, Track } from '@/utils'
  import {
    apiBlindBoxHomeActivityIndex,
    apiBlindBoxHomePrizeDanMu,
    apiBlindBoxOrderGetUnOpenCount,
  } from '@/api'
  import { Danmu2025 } from './components'
  import { navigateTo } from '@/router'

  export default Vue.extend({
    components: {
      Danmu2025,
    },

    mixins: [
      mapQuery({
        id: 'id',
      }),
      Track.provideMark(() => ({
        page: '多多盲盒首页',
      })),
    ],

    data: () => ({
      loading: true,
      homeData: {},
      danmus: [],
      unopenData: 0,
    }),

    activated() {
      this.prepareData()

      // 每隔3分钟刷新一次弹幕
      const boxId = this.id
      const timer = setInterval(async () => {
        const danmuData = await apiBlindBoxHomePrizeDanMu({
          id: boxId,
        })
        this.danmus = danmuData.map(item => item.text)
      }, 3 * 60 * 1000)
      addDispose(this, () => clearInterval(timer), true)
    },

    methods: {
      async prepareData() {
        const { homeData, danmuData, unopenData } = await prepareData({
          homeData: apiBlindBoxHomeActivityIndex({
            id: this.id,
          }),
          danmuData: apiBlindBoxHomePrizeDanMu({
            id: this.id,
          }),
          unopenData: apiBlindBoxOrderGetUnOpenCount(),
        })
        this.homeData = homeData
        this.danmus = danmuData.map(item => item.text)
        this.unopenData = unopenData
        this.loading = false
      },

      handleMyBoxClick() {
        navigateTo('BoxOrderList')
      },

      handleRuleClick() {
        navigateTo('BoxRule_2025', {
          id: this.id,
        })
      },

      handleItemClick(item) {
        navigateTo('BoxDetail_2025', {
          id: item.boxId,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    // background: linear-gradient(360deg, #9c008e 0%, #6500e4 100%);
    background: linear-gradient(360deg, #9c0000 0%, #e40000 100%);
  }

  .header {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    box-sizing: border-box;
    color: white;

    .back {
      flex-shrink: 0;
      font-size: 16px;

      &:active {
        opacity: 0.8;
      }
    }

    .title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      line-height: 25px;
      text-align: center;
    }

    .my {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      font-size: 0;

      .icon {
        font-size: 20px;
      }

      .text {
        margin-left: 4px;
        font-size: 12px;
        line-height: 17px;
        // color: #ffffff;
      }
    }
  }

  .headImage {
    position: relative;
    font-size: 0;

    .image {
      width: 100%;
    }

    .floatRule {
      position: absolute;
      right: 0;
      top: 173px;
      width: 32px;
      height: 73px;
      box-sizing: border-box;
      padding-left: 8px;
      background-image: url('./images/首页规则浮标背景.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-size: 14px;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  .layoutHelper {
    margin-top: -300px;
  }

  .danmu {
    width: 100%;
    height: 82px / 3 * 2;
    background-color: transparent;
  }

  .list {
    margin-top: 20px;
    padding: 0 12px;

    .item {
      position: relative;
      background: #f57171;
      box-shadow: inset 0px 1px 10px 0px rgba(255, 169, 169, 1);
      border-radius: 8px;
      padding: 11px;
      font-size: 0;
      overflow: hidden;

      .container {
        display: flex;
        flex-direction: column;
        background: linear-gradient(120deg, #fff7f5 0%, #fed8da 100%);
        border-radius: 8px;
        padding: 8px;

        .cover {
          flex-shrink: 0;
          position: relative;

          .image {
            width: 100%;
            height: 166px;
            border-radius: 8px;
            object-fit: cover;
          }
        }

        .content {
          position: relative;
          margin-top: 8px;
          flex-grow: 1;

          .title {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            color: #503037;
            line-height: 22px;
          }

          .count {
            margin-top: 8px;
            font-size: 14px;
            color: #bd7683;
            line-height: 20px;
          }

          .extra {
            margin-top: 8px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .button {
              position: absolute;
              right: -4px;
              bottom: -8px;
              width: 132px;
              height: 50px;
              background-image: url('./images/开盲盒按钮.png');
              background-position: center;
              background-repeat: no-repeat;
              background-size: 100% 100%;
              padding: 2px 8px 11px 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 16px;
              font-weight: bold;
              color: #ffffff;
              box-sizing: border-box;
            }
          }
        }
      }

      .tag {
        position: absolute;
        left: 0;
        top: 0;
        background: linear-gradient(180deg, #fffbca 0%, #fad879 100%);
        border-radius: 0 0px 8px 0px;
        font-size: 12px;
        font-weight: bold;
        color: #a80e0e;
        line-height: 17px;
        padding: 4px 8px;
      }

      + .item {
        margin-top: 12px;
      }

      &.sold {
        pointer-events: none;

        .container {
          .cover {
            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              background-image: url('./images/已售罄.png');
              background-position: center;
              background-repeat: no-repeat;
              background-size: cover;
              border-radius: 8px;
            }
          }

          .extra {
            .button {
              background-image: url('./images/已售罄按钮.png');
            }
          }
        }
      }
    }
  }

  .rule {
    position: relative;
    padding: 12px;
    background: #f57171;
    box-shadow: inset 0px 1px 10px 0px rgba(255, 169, 169, 1);
    border-radius: 8px;
    margin: 30px 12px 12px 12px;

    .container {
      background: #ffe7e7;
      border-radius: 8px;

      .title {
        position: absolute;
        top: -5.5px;
        left: 50%;
        transform: translateX(-50%);
        width: 188px;
        height: 43px;
        background-image: url('./images/标题背景.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-size: 18px;
        font-weight: bold;
        color: #740100;
        line-height: 25px;
        padding-top: 5px;
        text-align: center;
        box-sizing: border-box;
      }

      .content {
        font-size: 14px;
        color: #a80000;
        line-height: 22px;
        padding: 37px 12px 0 12px;
        white-space: pre-line;
      }
      .tips {
        margin-top: 9px;
        padding: 0 12px 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #ff0000;
        line-height: 22px;
        text-align: center;
        font-style: normal;
      }
    }
  }
</style>
